import { styled } from '@nykaa/ui-components';
import { DWEB_MAX_WIDTH, COLORS } from 'shared/styles/base';
import { truncate } from 'shared/styles/mixin';

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: ${DWEB_MAX_WIDTH}px;
  width: auto;
  border-radius: 3px;
  text-align: center;
  line-height: 0;
  object-fit: contain;
  flex: 1 0 auto;
`;

export const Anchor = styled(Container.withComponent('a'))`
  text-decoration: none;
`;

export const Description = styled.p<{ align: string }>`
  ${truncate}
  height: 24px;
  display: block;
  color: #000;
  ${({ theme }) => theme.typography.type201};
  margin: 0;
  text-align: ${(props) => (props.align ? props.align : `left`)};
`;

export const SubDescription = styled.p<{ align: string }>`
  ${truncate}
  height: 20px;
  display: block;
  color: ${COLORS.BLACK_64};
  ${({ theme }) => theme.typography.bodyLarge};
  margin: 0;
  text-align: ${(props) => (props.align ? props.align : `left`)};
`;
